import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  @media (max-width: 1585px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
